// 项目中已经存在一个 FJCanvasPool, 但是里面的接口跟输出业务耦合，比如 clear

import FJPoolCanvas from '../core/FJPool/FJPoolCanvas';

// 所以这里新建一个通用的池单例，用于其他的应用场景
const _canvasPool = new FJPoolCanvas();

/**
 * 获取画布
 *
 * @param {string} contextType
 * @returns
 */
function getCanvas(contextType = '2d', isOffscreen = false) {
    return _canvasPool.getItem({ contextType, isOffscreen });
}

/**
 * 释放画布
 *
 * @param {HTMLCanvasElement} canvas
 */
function releaseCanvas(canvas) {
    _canvasPool.releseItem(canvas);
}

export default {
    getCanvas,
    releaseCanvas,
};
